import { useNavigate } from 'react-router-dom';

import { Button } from '@motorway/mw-highway-code';

import { clearSessionToken } from '../../api/helpers/auth.helpers';
import { ROUTES } from '../../helpers/routes';
import { snowplowCtaClick } from '../../helpers/snowplow';

export const SignOut = () => {
  const navigate = useNavigate();

  const LABEL = 'End collection';

  return (
    <p>
      <Button
        label={LABEL}
        onClick={() => {
          clearSessionToken();
          snowplowCtaClick({
            button_label: LABEL,
            name: 'inspection_end_clicked',
            url: ROUTES.FINISHED,
          });
          navigate(ROUTES.FINISHED, { replace: true });
        }}
        reverse
        showLabel
        size="medium"
        type="button"
      />
    </p>
  );
};
